export const messages_el = {
    nameEmpty: "Το όνομα δεν μπορεί να είναι κενό",
    emailEmpty: "Το email δεν μπορεί να είναι κενό",
    emailNotValid: "Το email δεν είναι σωστό. Παρακαλούμε εισάγετε μια έγκυρη διεύθυνση.",
    locationEmpty: "Η τοποθεσία δεν μπορεί να είναι κενή",
    interests: "Διάλεξε 3 κατηγορίες",
    profileSaved: "Οι λεπτομέρειες του προφίλ σου αποθηκεύτηκαν",
    profilePic: "Η φωτογραφία του προφίλ σου αποθηκεύτηκε",
    addToFavorites:"Αποθηκεύτηκε στα αγαπημένα",
    removeFromFavorites:"Αφαιρέθηκε από τα αγαπημένα"
};


// WEBPACK FOOTER //
// ./src/constants/messages_el.js